import React, { FC, useEffect, useMemo } from 'react'

import useContractNamesContext from '@common/hooks/useContractNamesContext/useContractNamesContext'

import { ContractNameChildren } from './types'

/**
 * Non-extension builds (mobile-web, benzin): the ContractNamesController runs
 * in-process, mounted by `ContractNamesContextProvider`.
 */
const LocalContractName: FC<{
  address: string
  chainId: bigint
  children: ContractNameChildren
}> = ({ address, chainId, children }) => {
  const { contractNamesCtrl, state } = useContractNamesContext()

  const name = useMemo(() => state?.contractNames?.[address]?.name || undefined, [state, address])

  useEffect(() => {
    if (name || typeof contractNamesCtrl?.getName !== 'function') return

    contractNamesCtrl.getName(address, chainId)
  }, [address, chainId, contractNamesCtrl, name])

  return <>{children(name)}</>
}

export default LocalContractName
